export default "/_next/static/assets/images/spinner-dark.5dcc457c3e785080d936c9d35d25e8a7.svg";